var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { Controller, } from "react-hook-form";
import { ErrorMessage } from "./ValidationMessage";
export const SAutoComplete = (_a) => {
    var { name, control, label, options, error, helperText, size = "medium", rules } = _a, props = __rest(_a, ["name", "control", "label", "options", "error", "helperText", "size", "rules"]);
    return (React.createElement(Controller, { name: name, control: control, rules: rules, render: (_a) => {
            var _b = _a.field, { onChange, value = [] } = _b, field = __rest(_b, ["onChange", "value"]), { fieldState: { error: fieldError } } = _a;
            const selectedOptions = options.filter((opt) => value.includes(opt.value));
            return (React.createElement(Box, null,
                React.createElement(Autocomplete, Object.assign({ multiple: true, 
                    // Default MUI behaviour closes the popup after every pick, which turns
                    // choosing several options (e.g. access points) into a repeated
                    // open-tap-closed cycle — especially painful on mobile. Keep it open
                    // until the user taps away, like the standard multi-select pattern.
                    disableCloseOnSelect: true, options: options, getOptionLabel: (option) => option.label, isOptionEqualToValue: (option, val) => option.value === (val === null || val === void 0 ? void 0 : val.value), value: selectedOptions, onChange: (_, newValue) => {
                        var _a;
                        return onChange(newValue.some((item) => item.value === "everyone") ||
                            newValue.some((item) => item.value === "active")
                            ? [
                                (_a = newValue.find((item) => item.value === "everyone" || item.value === "active")) === null || _a === void 0 ? void 0 : _a.value,
                            ]
                            : newValue.map((item) => item.value));
                    }, getOptionDisabled: (option) => (selectedOptions.some((sel) => sel.value === "everyone") &&
                        option.value !== "everyone") ||
                        (selectedOptions.some((sel) => sel.value === "active") &&
                            option.value !== "active")
                        ? true
                        : option.disabled, renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { label: label, error: !!fieldError || !!error, fullWidth: true, size: size, variant: "filled", InputProps: Object.assign(Object.assign({}, params.InputProps), { endAdornment: (React.createElement(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    '& .MuiAutocomplete-endAdornment': {
                                        '& .MuiIconButton-root': {
                                            width: 32,
                                            height: 32,
                                        },
                                    },
                                } }, params.InputProps.endAdornment)) }) }))) }, field, props, { slotProps: Object.assign({ listbox: {
                            // Cap how tall the popper wants to be so it rarely needs to flip
                            // above the field on short mobile viewports, and scrolls instead
                            // of pushing options past the edge of the screen.
                            sx: { maxHeight: 320 },
                        } }, props.slotProps), sx: Object.assign({ '& .MuiAutocomplete-endAdornment .MuiIconButton-root': {
                            width: 32,
                            height: 32,
                        }, '& .MuiAutocomplete-tag': {
                            marginTop: 4,
                            marginBottom: 4,
                        } }, props.sx) })),
                React.createElement(ErrorMessage, { error: (fieldError === null || fieldError === void 0 ? void 0 : fieldError.message) || (error === null || error === void 0 ? void 0 : error.message) || helperText })));
        } }));
};
